import { Building2, ChevronDown, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Skeleton } from '@/components/ui/skeleton';
import { useActiveUnit } from '@/contexts/ActiveUnitContext';

export const UnitSwitcher = () => {
    const { activeUnitId, activeUnitName, units, isLoading, setActiveUnit } = useActiveUnit();

    if (isLoading) {
        return <Skeleton className="h-9 w-36" />;
    }

    if (units.length === 0) {
        return null;
    }

    // Apenas 1 unidade — exibe sem dropdown
    if (units.length === 1) {
        return (
            <div className="flex items-center gap-1.5 text-sm text-muted-foreground px-2">
                <Building2 className="h-4 w-4 shrink-0" />
                <span className="truncate max-w-[160px]">{units[0].nome}</span>
            </div>
        );
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    className={`gap-1.5 max-w-[200px] ${!activeUnitId ? 'text-amber-600 dark:text-amber-400' : ''}`}
                >
                    <Building2 className="h-4 w-4 shrink-0" />
                    <span className="truncate">
                        {activeUnitName ?? 'Selecione unidade…'}
                    </span>
                    <ChevronDown className="h-3.5 w-3.5 shrink-0 opacity-50" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64">
                {units.map((u) => (
                    <DropdownMenuItem
                        key={u.id_unidade}
                        onClick={() => setActiveUnit(u.id_unidade)}
                        className="gap-2"
                    >
                        <Check
                            className={`h-4 w-4 shrink-0 ${
                                u.id_unidade === activeUnitId ? 'opacity-100' : 'opacity-0'
                            }`}
                        />
                        <span className="truncate">{u.nome}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
